var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmojiAgree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 36C28.4411 36 36.5 27.9411 36.5 18C36.5 8.05887 28.4411 0 18.5 0C8.55887 0 0.5 8.05887 0.5 18C0.5 27.9411 8.55887 36 18.5 36Z",
    fill: "#FFCC4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0152 23.621C11.0602 23.8 12.1832 28 18.5002 28C24.8182 28 25.9402 23.8 25.9852 23.621C26.0402 23.404 25.9422 23.179 25.7482 23.067C25.5532 22.956 25.3092 22.989 25.1482 23.144C25.1292 23.163 23.1942 25 18.5002 25C13.8062 25 11.8702 23.163 11.8522 23.145C11.7562 23.05 11.6282 23 11.5002 23C11.4162 23 11.3312 23.021 11.2542 23.064C11.0582 23.176 10.9602 23.403 11.0152 23.621Z",
    fill: "#664500"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 17C13.8807 17 15 15.433 15 13.5C15 11.567 13.8807 10 12.5 10C11.1193 10 10 11.567 10 13.5C10 15.433 11.1193 17 12.5 17Z",
    fill: "#664500"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 17C25.8807 17 27 15.433 27 13.5C27 11.567 25.8807 10 24.5 10C23.1193 10 22 11.567 22 13.5C22 15.433 23.1193 17 24.5 17Z",
    fill: "#664500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiAgree);
export default __webpack_public_path__ + "static/media/emoji-agree.bc42211f420ac87e5048783ffcf4839b.svg";
export { ForwardRef as ReactComponent };